import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Homepage from "../HomePage";
import Homepage2 from "../HomePage2";
import Homepage3 from "../HomePage3";
import AboutPage from "../AboutPage";
import PracticePage from "../PracticePage";
import PracticeDetails from "../PracticeDetails";
import ContactPage from "../ContactPage";
import FAQPage from "../FAQPage";
import BlogPage from "../BlogPage";
import BlogPostMainComponent from "../BlogPost";
import AdminSignInMainComponent from "../AdminSignIn";
import AdminSignUpMainComponent from "../AdminSignUp";
import UserSignInMainComponent from "../UserSignIn";
import UserSignUpMainComponent from "../UserSignUp";
import ForgotPasswordMainComponent from "../ForgotPassword";
import DashboardMainComponent from "../dashboard";
import ManageBlogMainComponent from "../ManageBlog";
import DeleteBlogMainComponent from "../DeleteBlog";
import ScheduleMeetingMainComponent from "../ScheduleMeeting";
import saveToApm from "../../apm";
import { useEffect} from "react";


const AllRoute = () => {
  useEffect(() => {
    saveToApm("New instance (router) created.");
  }, []);
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route exact path="/" component={Homepage} />
          <Route path="/home" component={Homepage} />
          <Route path="/home2" component={Homepage2} />
          <Route path="/home3" component={Homepage3} />
          <Route path="/about" component={AboutPage} />
          <Route path="/practice" component={PracticePage} />
          <Route path="/practice-details" component={PracticeDetails} />
          <Route path="/contact" component={ContactPage} />
          <Route path="/faq" component={FAQPage} />
          <Route path="/blog/:id" component={BlogPostMainComponent} />
          <Route path="/blog" component={BlogPage} />
          <Route path="/AdminSignIn" component={AdminSignInMainComponent} />
          <Route path="/AdminSignUp" component={AdminSignUpMainComponent} />
          <Route path="/UserSignIn" component={UserSignInMainComponent} />
          <Route path="/UserSignUp" component={UserSignUpMainComponent} />
          <Route
            path="/ForgotPassword"
            component={ForgotPasswordMainComponent}
          />
          <Route path="/dashboard" component={DashboardMainComponent} />
          <Route path="/ManageBlog" component={ManageBlogMainComponent} />
          <Route path="/DeleteBlog" component={DeleteBlogMainComponent} />
          <Route
            path="/scheduleMeeting"
            component={ScheduleMeetingMainComponent}
          />
        </Switch>
      </Router>
    </div>
  );
};

export default AllRoute;
